import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Route, Switch } from 'react-router-dom';
import Bookings from 'components/merchant/bookings'

const Dashboard = ({ match }) => (
  <Switch>
    <Route
      path={match.path}
      component={Bookings} />
  </Switch>
);

Dashboard.propTypes = {
  match: PropTypes.object,
};

export default withRouter(Dashboard);
